import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Img from "gatsby-image"
import MoreBlog from "../components/more-blog"
import SEO from "../components/seo"

export default ({ data }) => {
    const post = data.markdownRemark
    return (
        <Layout>
            <SEO title={post.frontmatter.title} />
            <div className="container">
                <h1 className="text-center mt-3">{post.frontmatter.title}</h1>
                <p className="text-center">{post.frontmatter.date}</p>
                <Img sizes={post.frontmatter.featuredImage.childImageSharp.fluid}/>
                <div class="row mt-3" >
                    <div class="col" dangerouslySetInnerHTML={{ __html: post.html }} />
                </div>
            </div>
            <MoreBlog />
        </Layout>
    )
}

export const query = graphql`
    query($slug: String!) {
        markdownRemark(fields: { slug: { eq: $slug } }) {
        html
        frontmatter {
            title
            date(formatString: "Do MMM Y")
            featuredImage {
                childImageSharp {
                    fluid(maxWidth: 1000) {
                        ...GatsbyImageSharpFluid_noBase64
                    }
                }
            }
        }
        }
    }
`